@if (reservation$ | async; as res) {
  <div right
       class="my-1 px-3 ms-auto me-1 text-muted">
    <small class="ms-auto text-muted me-2">{{ res.ArrivalDate | date: 'dd'
    }}{{
    res.DepartureDate
    | date
    : ' - dd
    MMM'
    }}</small>
  </div>
}